<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog
    width="500px"
    :value="showWarningPaymentState"
    @input="toggleWarningPaymentState"
    scrollable
  >
    <v-card class="kbLight">
      <v-toolbar class="kbLightBlue" dark text>
        <div class="text-h6">{{$t('general.warning')}}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleWarningPaymentState(false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="kbDarkBlue--text">
          {{$t('general.rechargeToAvoidBlockingMainFunctions')}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="toggleWarningPaymentState(false)">Cerrar</v-btn>
        <v-btn
          color="primary"
          @click="togglePaymentDialog(true)"
        >{{$t('general.load')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      showWarningPaymentState: state => state.payments.showWarningPaymentStateDialog
    })
  },
  methods: {
    toggleWarningPaymentState (value) {
      this.$store.commit('TOGGLE_WARNING_PAYMENT_STATE_DIALOG', value)
    },
    togglePaymentDialog (value) {
      this.toggleWarningPaymentState(false)
      this.$store.commit('TOGGLE_NEW_PAYMENT_DIALOG', value)
    }
  }
}
</script>
